import React, { useEffect } from 'react';

export default function AppDownload() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const role = params.get('role'); // 'buyer' or 'vendor'
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    let destination = '';

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      // iOS User
      if (role === 'vendor') {
        // Vendor iOS app is not published yet, redirect to general info page or buyer iOS app
        destination = 'https://apps.apple.com/us/app/kanjusee/id6782860992';
      } else {
        destination = 'https://apps.apple.com/us/app/kanjusee/id6782860992';
      }
    } else if (/android/i.test(userAgent)) {
      // Android User
      if (role === 'vendor') {
        destination = 'https://play.google.com/store/apps/details?id=com.gs.kanjusee.seller';
      } else {
        destination = 'https://play.google.com/store/apps/details?id=com.gs.kanjusee.buyer';
      }
    } else {
      // Desktop / Other OS -> Redirect to homepage
      destination = '/';
    }

    window.location.href = destination;
  }, []);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      background: '#FAF8F3',
      color: '#1A1A1A'
    }}>
      <div style={{ fontSize: 18, fontWeight: 700, color: '#1B5C3A', marginBottom: 16 }}>
        Redirecting you to the App Store...
      </div>
      <div style={{
        width: 40,
        height: 40,
        border: '4px solid #E5E7EB',
        borderTopColor: '#1B5C3A',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }} />
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}
